<template>
  <div class="row-block header">
    <h1>{{ $tr('analytics.title') }}</h1>

    <Selectors class="selectors"/>

    <DatePicker class="align-end" :loading="loading"/>
  </div>
</template>

<script>
import Selectors from './Selectors.vue';
import DatePicker from './DatePicker.vue';

import { mapGetters } from 'vuex'

export default {
  name: 'analytics-filters',

  components: {
    Selectors,
    DatePicker
  },

  computed: {
    loading () {
      return this.averageLoading ||
             this.conversionLoading ||
             this.funnelLoading ||
             this.pieLoading ||
             this.durationLoading
    },

    ...mapGetters({
      averageLoading: 'analytics/averageTime/loading',
      conversionLoading: 'analytics/conversion/loading',
      funnelLoading: 'analytics/funnel/loading',
      pieLoading: 'analytics/pieChart/loading',
      durationLoading: 'analytics/totalInterviewDuration/loading'
    })
  }
}
</script>

<style lang="scss" scoped>
  .header {
    padding: 10px 0 30px;

    h1 {
      margin: 0;
      font-weight: normal;
      line-height: normal;
      font-size: 28px;
    }

    .selectors { margin-left: 10px; }

    .align-end { margin-left: auto; }
  }
</style>
